// extracted by mini-css-extract-plugin
module.exports = {"quantityField":"CargoMainInfoForm_quantityField__3LYq_","weightField":"CargoMainInfoForm_weightField__MnWwt"};